import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { nl } from "./locales/nl";
import { en } from "./locales/en";
// Side-effect import: augments i18next with typed translation keys.
import "./locales/types";

export type Locale = "nl" | "en";
export const LOCALE_STORAGE_KEY = "avds:locale";

function getInitialLocale(): Locale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    return stored === "en" ? "en" : "nl";
  } catch {
    return "nl";
  }
}

void i18n.use(initReactI18next).init({
  resources: {
    nl: { translation: nl },
    en: { translation: en },
  },
  lng: getInitialLocale(),
  fallbackLng: "nl",
  interpolation: { escapeValue: false },
});

export default i18n;
